module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-03.e08e766a.png";